import { modulePaths } from '@/routes/paths';

export function buildInvoiceNewUrl(options?: {
  commercialOperationId?: string;
  clientId?: string;
}): string {
  const sp = new URLSearchParams();
  if (options?.commercialOperationId) {
    sp.set('operation', options.commercialOperationId);
  }
  if (options?.clientId) sp.set('client', options.clientId);
  const q = sp.toString();
  return q
    ? `${modulePaths.billing}/facturas/nueva?${q}`
    : `${modulePaths.billing}/facturas/nueva`;
}

export function parseInvoicePrefill(searchParams: URLSearchParams): {
  commercialOperationId?: string;
  clientId?: string;
} {
  const commercialOperationId = searchParams.get('operation') ?? undefined;
  const clientId = searchParams.get('client') ?? undefined;
  const out: { commercialOperationId?: string; clientId?: string } = {};
  if (commercialOperationId) out.commercialOperationId = commercialOperationId;
  if (clientId) out.clientId = clientId;
  return out;
}
